module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAAICAYAAADp9wbEAAAAAXNSR0IArs4c6QAAAQFJREFUeAHt2KENgFAQA1BgKQZhG3ZiChRBMAFBYsB/BzPUnHqnr2nyZPt5v7/OESBAgACBQOB53+W6zimIeCVAgAABAt16HFtrbURBgAABAgRSgSEN+CdAgAABAgQIECBAgAABAgQIECBQKWDAqtTWRYAAAQIECBAgQIAAAQIECBAgEAsYsGIyAQIECBAgQIAAAQIECBAgQIAAgUoBA1alti4CBAgQIECAAAECBAgQIECAAIFYwIAVkwkQIECAAAECBAgQIECAAAECBAhUChiwKrV1ESBAgAABAgQIECBAgAABAgQIxAIGrJhMgAABAgQIECBAgAABAgQIECBAoFLgB50OD+XIlcVvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/assets/login/img/borda-body-bottom.png
// module id = 1232
// module chunks = 0